export const TAX_TYPES = [
	{ text: "Exempt", salesTaxId: 0 },
	{ text: "Taxed", salesTaxId: 1 },
];

// Online payment page printed on invoices as a QR code and typed link (#1472)
export const PAYMENT_URL = "https://teamleader.com/pay";
export const PAYMENT_URL_DISPLAY = "teamleader.com/pay";
